const storageKey = "prs-training-finance";

const local = {
    getData: () => JSON.parse(localStorage.getItem(storageKey)),
    saveData: data => localStorage.setItem(storageKey, JSON.stringify(data)),
    clearData: () => localStorage.removeItem(storageKey),
}

export default local;